import React, { useState } from "react"
import Select from 'react-select';
import { Row, Col, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
// import { useHistory } from "react-router-dom"
// import { getDoctorLocation } from '../../doctorapi'
import './locate.css'
import { Formik, Field } from 'formik';
// import { ButtonsWrap, ModalWrap } from "./styles";
import 'react-toastify/dist/ReactToastify.css';
import { FormWrap, SearchButton, FindButton } from "./styles";
// import { FaMapMarkerAlt } from "react-icons/fa";
import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyBFTEG2DxMcjMh8FUt3lRdXyQ85wJrJj0c");
Geocode.setLanguage("en");

const Locatedoctor = (props) => {
    const [isCheckinputValues, setIsCheckinputValues] = useState(false)
    toast.configure()
    const options = [
        { label: '10 Miles', value: "10" },
        { label: '25 Miles', value: "25" },
        { label: '50 Miles', value: "50" },
        { label: '100 Miles', value: "100" },
        { label: '200 Miles', value: "200" },
        { label: '500 Miles', value: "500" }

    ];
    const initialState = {
        longitude: "",
        miles: 40225,
        latitude: "",
        zipcode: ""
    }
    const [searchValues, setSearchValues] = useState(initialState)
    let getLatLong
    const handleZip = async (input) => {
        const zipValue = { ...searchValues, zipcode: input }
        setSearchValues(zipValue)
        props.setZipCodeValue(input)
        // Geocode.fromAddress(input).then(
        //     response => {
        //         const { lat, lng } = response.results[0].geometry.location;
        //         let latValues = { ...searchValues, latitude: lat, longitude: lng }
        //         setSearchValues(latValues)
        //     },
        //     error => {
        //         console.error(error);
        //     }
        // );
    }

    const handleMileSelect = (values) => {
        const zipValue = { ...searchValues, miles: parseInt(values) * 1609 }
        setSearchValues(zipValue)
    }

    const handleProductSelect = (value) => {
        let values = [...props.productTypes]
        let index = values.indexOf(value);
        if (index === -1) {
            values.push(value);
        } else {
            values.splice(index, 1);
        }
        props.setProductTypes(values);
    }
    return (
        <div>
            <FormWrap>
                <Formik
                    initialValues={{ zipcode: '', miles: { label: '25 Miles', value: "25" }, latitude: '', longitude: '' }}
                    validate={values => {
                        const errors = {};
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setIsCheckinputValues(true)
                        if (searchValues.zipcode && searchValues.zipcode.length > 4) {
                            Geocode.fromAddress(searchValues.zipcode).then(
                                response => {
                                    const { lat, lng } = response.results[0].geometry.location;
                                    let latValues = { ...searchValues, latitude: lat, longitude: lng, productTypes: props.productTypes };
                                    props.handleMapListing(latValues);
                                    resetForm(values);
                                    setSearchValues(initialState)
                                },
                                error => {
                                    console.log('error', error);
                                    toast.error("Please enter a valid zipcode");
                                },
                            );
                        } else if (!searchValues.zipcode && props.productTypes.length) {
                            props.handleMapListing({ ...searchValues, productTypes: props.productTypes });
                            resetForm(values);
                            setSearchValues(initialState)
                        }
                        else if(searchValues.zipcode && searchValues.zipcode.length<0) {
                            toast.error("Zipcode must be at least 5 digits");
                        }else{
                            props.handleMapListing({ ...searchValues, productTypes: props.productTypes });
                        }


                    }}
                    enableReinitialize={true}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm
                    }) => (
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="6" xl="3">
                                        <label>Zip Code</label>
                                        <Field
                                            type="text"
                                            name="zipcode"
                                            onChange={(e) => {
                                                setFieldValue("zipcode", e.target.value)
                                                handleZip(e.target.value)
                                            }}
                                            className="zip_Code"
                                        />
                                    </Col>
                                    <Col md="6" xl="3">
                                        <label>Distance</label>
                                        <Select
                                            name="miles"
                                            onChange={miles => {
                                                setFieldValue("miles", miles)
                                                handleMileSelect(miles.value)
                                            }}
                                            options={options}
                                            value={values.miles}
                                            classNamePrefix="distance-select"
                                        />
                                    </Col>
                                    {/* <FlexWrap> */}
                                    <Col md="6" xl="3">
                                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginTop: '2.5rem'}}>
                                        <div style={{display:'flex', alignItems:'center'}}>
                                        <input
                                        style={{width: '20px',
                                            height: '20px'}}
                                            name="centerOfExcellence"
                                            type="checkbox"
                                            checked={props.productTypes.includes('Axonics SNM')}
                                            onChange={e => handleProductSelect('Axonics SNM')} />
                                        <p style={{margin:'0px', marginLeft:'10px'}}>Axonics SNM</p>
                                        </div>
                                        <div style={{display:'flex', alignItems:'center'}}>
                                        <input
                                        style={{width: '20px',
                                        height: '20px'}}
                                            name="centerOfExcellence"
                                            type="checkbox"
                                            checked={props.productTypes.includes('Bulkamid')}
                                            onChange={e => handleProductSelect('Bulkamid')} />
                                        <p style={{margin:'0px', marginLeft:'10px'}}>Bulkamid</p>
                                        </div>
                                        </div>
                                    </Col>
                                    {/* </FlexWrap> */}
                                    <Col md="6" xl="3">
                                        <SearchButton disabled={props.isLoading} type="submit" >
                                            { props.isLoading ?
                                              <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                              : 'Submit'
                                            }
                             </SearchButton>
                                    </Col>
                                </Row>
                            </form>
                        )}
                </Formik>
            </FormWrap>
        </div>
    )
}

export default Locatedoctor



// WEBPACK FOOTER //
// ./src/component/Locatedoctor/index.js